import { Goal, MetricEntry, MetricEntryMode } from '@griply/types';
import { startOfDay } from 'date-fns';

import { formatDateKey } from '../format-date-key';

// The zero every cumulative progress series starts from, so a chart begins at the goal's start day.
export const goalStartEntry = (goal: Goal): MetricEntry => {
  const date = startOfDay(goal.startDate ?? goal.createdAt);

  return {
    id: formatDateKey(date),
    date,
    value: 0,
    mode: MetricEntryMode.Absolute,
  };
};
